module.exports = __webpack_public_path__ + "img/oak.aee84e2b.png";